import { render, staticRenderFns } from "./CaregiverTable.vue?vue&type=template&id=5b535ed8"
import script from "./CaregiverTable.vue?vue&type=script&lang=js"
export * from "./CaregiverTable.vue?vue&type=script&lang=js"
import style0 from "./CaregiverTable.vue?vue&type=style&index=0&id=5b535ed8&prod&lang=scss"
import style1 from "./CaregiverTable.vue?vue&type=style&index=1&id=5b535ed8&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports